import React, { useEffect, useState } from "react";

import { Button, Divider, Input, Space, Table, Tag } from "antd";
import type { TableProps } from "antd";
import axios from "axios";
import { addNotification } from "../store/slices/notificationSlice";
import { useDispatch } from "react-redux";

interface User {
  id: number;
  username: string;
  password: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  role: string;
}

interface ManageTeamProps {
  data: User[];
  userId: string | undefined;
}

const ManageTeam: React.FC<ManageTeamProps> = ({ data, userId }) => {
  const [newMember, setNewMember] = useState<String>("");
  const dispatch = useDispatch();

  const columns: TableProps<User>["columns"] = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          onClick={() => {
            axios
              .delete(`/dependants/${userId}/remove/${record.id}`)
              .then(() => {
                window.location.reload();
                // Optionally, you can refresh the data or remove the user from the state
                console.log("User deleted successfully");
              })
              .catch(({ response }) => {
                // Handle error
                console.error("Failed to delete user:", response?.data);
                dispatch(
                  addNotification({
                    type: "error",
                    message:
                      response?.data?.message ?? "Failed to delete team member",
                  })
                );
              });
          }}
        >
          X
        </Button>
      ),
    },
  ];

  if (!userId) {
    return <></>;
  }
  return (
    <>
      <Divider />
      <center>
        <h1>Manage Team</h1>
      </center>
      <Table<User> columns={columns} dataSource={data} />
      <Space.Compact style={{ width: "100%" }}>
        <Input
          placeholder="Enter Username"
          onChange={(c) => setNewMember(c.currentTarget.value)}
        />
        <Button
          type="primary"
          onClick={() => {
            axios
              .post(`/dependants/${userId}/create`, {
                username: newMember,
              })
              .then(() => {
                window.location.reload();
              })
              .catch(({ response }) => {
                dispatch(
                  addNotification({
                    type: "error",
                    message:
                      response?.data?.message ?? "Failed to add team member",
                  })
                );
              });
          }}
        >
          Submit
        </Button>
      </Space.Compact>
    </>
  );
};

export default ManageTeam;
